export const STAGING_LEGACY_WIDGET_URL = "https://staging-assetscdn.stackla.com"
export const PRODUCTION_LEGACY_WIDGET_URL = "https://assetscdn.stackla.com"

export const STAGING_DATA_URL = "https://widget-data.teaser.stackla.com"
export const STAGING_UI_URL = "https://widget-ui.teaser.stackla.com"

export const PRODUCTION_DATA_URL = "https://widget-data.stackla.com"
export const PRODUCTION_UI_URL = "https://widget-ui.stackla.com"

export const STAGING_LEGACY_WIDGET_DOMAIN = "widgetapp.teaser.stackla.com"
export const PRODUCTION_LEGACY_WIDGET_DOMAIN = "widgetapp.stackla.com"
